import { Buffer } from 'buffer';

const process = { env: {}, cwd: () => '/', browser: true };

export { Buffer, process };
